// src/components/sidebar/Sidebar.js
import React from 'react';
import PropTypes from 'prop-types';
import './Sidebar.css';

// Импорт иконок (пример):
import assetsLogo from '../../images/assets.svg';
import reservLogo from '../../images/reserv.svg';
import expensesLogo from '../../images/expenses.svg';
import expensesyearlyLogo from '../../images/expensesyearly.svg';
import flatLogo from '../../images/flat.svg';
import rentLogo from '../../images/rent.svg';
import incomeLogo from '../../images/income.svg';
import contactsBanner from '../../images/сontacts.png';
import analyticsLogo from '../../images/analytics.svg';
// Можно добавить rentLogo, yearlyExpensesLogo, analyticsLogo и т.д.

const Sidebar = ({ activeSection, handleToggleSection }) => {
  const sections = [
    { id: 'income', title: 'Доходы', logo: incomeLogo },
    { id: 'expenses', title: 'Расходы', logo: expensesLogo },
    { id: 'yearlyExpenses', title: 'Годовые расходы', logo: expensesyearlyLogo },
    { id: 'assets', title: 'Активы', logo: assetsLogo },
    { id: 'reserve', title: 'Резервы', logo: reservLogo },
    { id: 'flat', title: 'Квартира в кредит', logo: flatLogo },
    { id: 'rent', title: 'Аренда', logo: rentLogo },
    { id: 'analytics', title: 'Аналитика', logo: analyticsLogo },
  ];

  return (
    <>
      {sections.map((section) => (
        <div
          key={section.id}
          className={`sidebarItem ${activeSection === section.id ? 'active' : ''}`}
          onClick={() => handleToggleSection(section.id)}
        >
          <div className="logo">
            <img src={section.logo} alt={section.title} />
          </div>
          <div className="title">{section.title}</div>
        </div>
      ))}

       <h2 className="contactText">Связаться с автором:</h2>

       <div className="bannerContainer">
         <a
           href="https://t.me/sergiovalor"
           target="_blank"
           rel="noopener noreferrer"
         >
           <img
             src={contactsBanner}
             alt="Связаться с автором"
             className="contactsBanner"
           />
         </a>
       </div>
    </>
  );
};

Sidebar.propTypes = {
  activeSection: PropTypes.string,
  handleToggleSection: PropTypes.func.isRequired,
};

export default Sidebar;
